/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BidirectionalActionConfig } from './BidirectionalActionConfig';
import {
    BidirectionalActionConfigFromJSON,
    BidirectionalActionConfigFromJSONTyped,
    BidirectionalActionConfigToJSON,
    BidirectionalActionConfigToJSONTyped,
} from './BidirectionalActionConfig';

/**
 * 
 * @export
 * @interface GetBiDirectionalConfig200Response
 */
export interface GetBiDirectionalConfig200Response {
    /**
     * 
     */
    data?: BidirectionalActionConfig;
}

/**
 * Check if a given object implements the GetBiDirectionalConfig200Response interface.
 */
export function instanceOfGetBiDirectionalConfig200Response(value: object): value is GetBiDirectionalConfig200Response {
    return true;
}

export function GetBiDirectionalConfig200ResponseFromJSON(json: any): GetBiDirectionalConfig200Response {
    return GetBiDirectionalConfig200ResponseFromJSONTyped(json, false);
}

export function GetBiDirectionalConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBiDirectionalConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BidirectionalActionConfigFromJSON(json['data']),
    };
}

export function GetBiDirectionalConfig200ResponseToJSON(json: any): GetBiDirectionalConfig200Response {
    return GetBiDirectionalConfig200ResponseToJSONTyped(json, false);
}

export function GetBiDirectionalConfig200ResponseToJSONTyped(value?: GetBiDirectionalConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BidirectionalActionConfigToJSON(value['data']),
    };
}

